import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'mlb-archive-sidebar-collapsed';

export function useArchiveSidebarCollapse() {
  const [collapsed, setCollapsedState] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsedState((v) => !v), []);
  const setCollapsed = useCallback((value) => setCollapsedState(Boolean(value)), []);

  return { collapsed, toggle, setCollapsed };
}

export default useArchiveSidebarCollapse;
